import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

// very generic link component

const Link = (props) => {
  const { dispatch, children, to, href, onClick, callback, ...childProps } = props
  const url = to || href

  // WARNING: This may not work properly with event.stop[Immediate]Propagation() as there's no way to check for it
  const handleOnClick = (e) => {
    if (onClick && typeof onClick === 'function' && onClick(e) === false) return false
    if (e.defaultPrevented) return false // if the initial onClick function prevented default (url navigation is default)

    if (url) {
      e.preventDefault()
      dispatch(push(url))
    }

    if (callback && typeof callback === 'function') callback(e)
  }

  return <a onClick={handleOnClick} {...childProps}>{children}</a>
}

Link.propTypes = {
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  to: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func, // before we push the url
  callback: PropTypes.func // after pushing the url
}

Link.defaultProps = {
  disabled: false
}

const mapStateToProps = (state, ownProps) => ({})
const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Link)



// WEBPACK FOOTER //
// ./src/components/Link/Link.js